const axios = require('axios').default;
import parametersManager from '@/managers/parametersManager.js'

var config = {
    baseUrl: parametersManager.is_staging ? 'https://scanner-api.staging.neosus.tech/api' : 'https://scanner-api.neosus.tech/api'
};

var client = {
    getUserInformation: async (user_token) => {
      const response = await axios({
        method:"GET",
        url:"https://get.geojs.io/v1/ip/geo.js",
      });
      return response;
    },
    createSubscription: async (token, customer_name, price_id, product_id) => {
        return await axios({
            method: "POST",
            url: config.baseUrl + "/payment/subscriptions",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            data: {
                "customer_name": customer_name || '',
                "price_id": price_id,
                "product_id": product_id
            }
        });
    },
    unsubscribe: async (subscription_id) => {
      return await axios({
          method: "POST",
          url: config.baseUrl + "/payment/subscriptions/cancel",
          data: {
              "subscription_id": subscription_id
          }
      });
    },
    refound: async (subscription_id, description) => {
      return await axios({
          method: "POST",
          url: config.baseUrl + "/payment/subscriptions/refund",
          data: {
            "description": description,
            "email": "",
            "phone": "",
            "subscription_id": subscription_id
          }
      });
    },
    setPaymentId: async (user_token, user_id, paymentId) => {
      const response = await axios({
        method:"PATCH",
        url:config.baseUrl + "/payment/customer/"+user_id,
        headers: {
          "Authorization": `Bearer ${user_token}`,
        },
        data: {
            "payment_method_id": paymentId
        }
      });
      return response;
    },
    getStatus: async (user_token) => {
      const response = await axios({
        method:"GET",
        url:config.baseUrl + "/payment/status",
        headers: {
          "Authorization": `Bearer ${user_token}`,
        },
      });
      return response;
    },
    getProducts: async () => {
        const response = await axios.get(config.baseUrl + "/payment/products");
        return response.data.products;
    },
    createUser: async (token) => {
        return await axios({
          method: "POST",
          url: config.baseUrl + "/auth/apple_token",
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            "apple_id": token
          }
        });
      },


  };


export default client